
import objectPath from 'object-path'
import initialState from './initialState'

const mutations = {
  setField(state, { target, value }) {
    objectPath.set(state, target, value)
  },
  setBillingData(state, payload) {
    state.billingData = {
      ...state.billingData,
      ...payload
    }
  },
  setMethodSelectForm(state, payload) {
    state.methodSelectForm = {
      ...state.methodSelectForm,
      ...payload
    }
  },
  setInvoiceForm(state, payload) {
    state.invoiceForm = {
      ...state.invoiceForm,
      ...payload
    }
  },
  setBillingForm(state, payload) {
    state.billingForm = {
      ...state.billingForm,
      ...payload
    }
  },
  setInitialState(state) {
    this.state.payment = {
      ...initialState()
    }
  },
}

export default mutations